export default __webpack_public_path__ + "sounds/framework/new_success.3ac421cb.mp3?3ac421cb";